import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ReceiptPDF from "./ReceiptPDF";

const ReceiptDownloadButton = ({
  transaction,
  type,
  buttonText = "View Receipt",
}) => {
  // This ensures the component only renders on client side
  const [isClient, setIsClient] = React.useState(false);

  React.useEffect(() => {
    setIsClient(true);
  }, []);

  // Generate a useful filename based on transaction type and data
  const generateFilename = () => {
    let prefix = "";

    switch (type) {
      case "material":
        prefix = "Material_Purchase";
        break;
      case "worker":
        prefix = "Worker_Payment";
        break;
      case "received":
        prefix = "Received_Payment";
        break;
      case "vendor":
        prefix = "Vendor_Payment";
        break;
      case "contractor":
        prefix = "Contractor_Payment";
        break;
      case "refund":
        prefix = "Refund";
        break;
      default:
        prefix = "Transaction";
    }

    return `${prefix}_Receipt_${transaction.transaction_id}.pdf`;
  };

  // FIX: Merge top-level transaction fields with originalTransaction so
  // ReceiptPDF can access fields like desc, medium, project, etc.
  // Top-level fields (desc, medium, id...) take priority over originalTransaction fields.
  const mergedTransactionData = {
    ...(transaction.originalTransaction || {}),
    ...transaction,
  };

  return isClient ? (
    <PDFDownloadLink
      document={
        <ReceiptPDF transactionData={mergedTransactionData} type={type} />
      }
      fileName={generateFilename()}
      className="px-4 py-2 bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 flex items-center gap-2"
    >
      {({ blob, url, loading, error }) =>
        loading ? "Generating receipt..." : buttonText
      }
    </PDFDownloadLink>
  ) : (
    <button
      className="px-4 py-2 bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 flex items-center gap-2"
      disabled
    >
      {buttonText}
    </button>
  );
};

export default ReceiptDownloadButton;
